<template>
  <div id="menu">
    <el-menu
      :default-active="routerName"
      active-text-color="#222222"
      mode="horizontal"
      text-color="#222222"
      @select="onMenuChange"
    >
      <el-menu-item-group>
        <el-menu-item index="Projects">
          <img :src="ICON_PROJECTS" alt="全部项目" />
          <span slot="title">全部项目</span>
        </el-menu-item>
        <el-menu-item index="MyInvitation">
          <img :src="ICON_MY_INVITATION" alt="成员管理" />
          <span slot="title">成员管理</span>
        </el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group v-if="projectId && projectId > 0">
        <span slot="title">项目</span>
        <el-menu-item v-if="false" index="Dashboard">
          <img :src="ICON_DASHBOARD" alt="仪表盘" />
          <span slot="title">仪表盘</span>
        </el-menu-item>
        <el-menu-item index="QRCodeManagement">
          <img :src="ICON_QRCODE" alt="二维码管理" />
          <span slot="title">二维码管理</span>
        </el-menu-item>
      </el-menu-item-group>
      <el-menu-item-group v-if="projectId && projectId > 0">
        <span slot="title">项目设置</span>
        <el-menu-item index="UserManagement">
          <img :src="ICON_USERS" alt="用户管理" />
          <span slot="title">用户管理</span>
        </el-menu-item>
      </el-menu-item-group>
    </el-menu>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
// let _this = void 0

export default {
  name: 'Menu',
  components: {},
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {
      ICON_PROJECTS: require('@/assets/images/icon/icon_projects.svg'),
      ICON_MY_INVITATION: require('@/assets/images/icon/icon_user-management.svg'),
      ICON_DASHBOARD: require('@/assets/images/icon/icon_dashboard.svg'),
      ICON_QRCODE: require('@/assets/images/icon/icon_qrecode.svg'),
      ICON_PROJECT_INFO: require('@/assets/images/icon/icon_project-info.svg'),
      ICON_USERS: require('@/assets/images/icon/icon_users.svg'),
      routerName: 'Projects',
    }
  },
  computed: {
    ...mapState({
      PROJECT_ID: state => state.PROJECT_ID,
      ROUTER_PATH: state => state.ROUTER_PATH,
    }),
    ...mapGetters({
      projectId: 'getProjectId',
    }),
  },
  watch: {
    // 监听路由的变化，当前页面菜单处于高亮状态
    ROUTER_PATH(newValue) {
      this.routerName = newValue.name
    },
    routerName(newValue) {
      if (newValue === 'Editor') {
        this.routerName = 'QRCodeManagement'
      }
    },
  },
  created() {
    //     _this = this
  },
  mounted() {
    const { name } = JSON.parse(window.localStorage.getItem('RouterInfo'))
    this.$store.commit('setRouter', { name })
    this.routerName = name
  },
  destroy() {},
  methods: {
    onMenuChange(name) {
      this.routerName = name
      this.$store.commit('setRouter', { name })
    },
  },
}
</script>
<style lang="scss" scoped>
#menu {
  height: calc(100%);

  .el-menu--horizontal {
    height: calc(100%);
    border-right: none;
  }

  .el-menu-item {
    padding: 0 30px;
    border-left: 4px solid #ffffff;
  }

  .el-menu-item.is-active {
    border-left: 4px solid rgba(22, 58, 91, 1);
    background: linear-gradient(90deg, rgba(61, 107, 153, 0.15), rgba(22, 58, 91, 0.15));
  }

  .el-menu-item,
  .el-submenu__title {
    line-height: 40px;
    position: relative;
    height: 40px;
    list-style: none;
    white-space: nowrap;
  }

  .el-menu-item span {
    font-size: 14px;
    font-weight: 400;
    line-height: 27px;
    margin-left: 8px;
    text-align: left;
    color: #222222;
  }

  .el-menu-item-group__title {
    font-size: 12px;
    line-height: normal;
    padding: 2em 0 1em 20px;
    color: #888888;
  }

  .el-menu-item-group__title span {
    margin-left: 17px;
  }
}
</style>
<style lang="scss"></style>
